import React from "react";
import { Tabs } from "antd";
import { IItems, IItemsCheckin } from "store/lobby/lobby-model";
import { IUserData } from "store/user-session/user-session-model";
import useTranslation from "utils/hooks/useTranslation";
import ColumnsTableCheckin from "../checkin/columnsTableCheckin";
import RenderLobbyTable from "../renderLobbyTable";
import ColumnsTable from "../unit/columnsTable";
import * as S from "./../styled/index.styled";

interface IProps {
  hasCheckin: boolean;
  allowRequestDockEntryAction: boolean;
  allowRequestVehicleInboundAction: boolean;
  totalItemsCheckins: number;
  itemsCheckins: Array<IItemsCheckin>;
  pageIndexCheckin: number;
  searchFilter: string;
  totalItems: number;
  items: Array<IItems>;
  pageIndex: number;
  isConcierge: boolean;
  activeTab: string;
  userData: IUserData;
  isLoadingLobby: boolean;
  setActiveTab: (...args) => void;
  handleTableCheckinChange: (...args) => void;
  intervalCallApi: (...args) => void;
  lobbyChangeFieldValueCheckin: (...args) => void;
  lobbyUpdateFilterTable: (...args) => void;
  handleClickOutBound: (...args) => void;
  handleClickView: (...args) => void;
  handleTableChange: (...args) => void;
  lobbyChangeFieldValue: (...args) => void;
  handleClickCheckin: (...args) => void;
  handleClickVehicleAction: (...args) => void;
  handleClickVehicleEntryAuthorization: (...args) => void;
  handleClickViewDocument: (...args) => void;
}

const LobbyTabs = ({
  hasCheckin,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  totalItemsCheckins,
  itemsCheckins,
  pageIndexCheckin,
  searchFilter,
  totalItems,
  items,
  pageIndex,
  isConcierge,
  activeTab,
  userData,
  isLoadingLobby,
  setActiveTab,
  handleTableCheckinChange,
  intervalCallApi,
  lobbyChangeFieldValueCheckin,
  lobbyUpdateFilterTable,
  handleClickOutBound,
  handleClickView,
  handleTableChange,
  lobbyChangeFieldValue,
  handleClickCheckin,
  handleClickVehicleAction,
  handleClickVehicleEntryAuthorization,
  handleClickViewDocument,
}: IProps): JSX.Element => {
  const FEATURED_VEHICLES = useTranslation({ id: "featured_vehicles" });
  const VEHICLE_IN_LOCATION = useTranslation({ id: "vehicles_in_location" });

  const handlesClickInbound = {
    handleClickOutBound,
    handleClickView,
    handleClickVehicleAction,
    handleClickVehicleEntryAuthorization,
    handleClickViewDocument,
  };

  const handlesClickCheckin = {
    handleClickCheckin,
    handleClickVehicleAction,
    handleClickViewDocument,
  };

  return (
    <S.TabContainer>
      <Tabs onChange={(e) => setActiveTab(e)} activeKey={activeTab}>
        {hasCheckin && (
          <Tabs.TabPane tab={`${FEATURED_VEHICLES} (${totalItemsCheckins})`} key="1">
            <RenderLobbyTable
              columnsTable={ColumnsTableCheckin({ handlesClickCheckin, isConcierge, allowRequestVehicleInboundAction, allowRequestDockEntryAction, userData })}
              items={itemsCheckins}
              totalItems={totalItemsCheckins}
              handleTableChange={handleTableCheckinChange}
              pageIndex={pageIndexCheckin}
              rowKey={(record) => record.id}
              searchFilter={searchFilter}
              intervalCallApi={intervalCallApi}
              lobbyChangeFieldValue={lobbyChangeFieldValue}
              lobbyUpdateFilterTable={lobbyUpdateFilterTable}
              lobbyChangeFieldValueCheckin={lobbyChangeFieldValueCheckin}
              isLoadingLobby={isLoadingLobby}
            />
          </Tabs.TabPane>
        )}
        <Tabs.TabPane tab={`${VEHICLE_IN_LOCATION} (${totalItems})`} key="2">
          <RenderLobbyTable
            columnsTable={ColumnsTable({ handlesClickInbound, isConcierge, allowRequestDockEntryAction, userData })}
            items={items}
            totalItems={totalItems}
            handleTableChange={handleTableChange}
            pageIndex={pageIndex}
            rowKey={(record) => record.id}
            searchFilter={searchFilter}
            intervalCallApi={intervalCallApi}
            lobbyChangeFieldValue={lobbyChangeFieldValue}
            lobbyUpdateFilterTable={lobbyUpdateFilterTable}
            lobbyChangeFieldValueCheckin={lobbyChangeFieldValueCheckin}
            isLoadingLobby={isLoadingLobby}
          />
        </Tabs.TabPane>
      </Tabs>
    </S.TabContainer>
  );
};

export default LobbyTabs;
